import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@core-services/auth.service';
import {RedeService} from '@core/services/rede.service';

/**
 * Sem login, as telas públicas (visitante) só abrem de dentro da rede da
 * ARTESP; fora dela vai pro login. Com login passa direto.
 */
export const redeGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const redeService = inject(RedeService);
  if (authService.isAuthenticated()) return true;
  return (await redeService.verificar()) ? true : router.parseUrl('/auth/login');
};
